// extracted by mini-css-extract-plugin
export default {"container":"STnBln","title":"ACoJhW","description":"mHPkXm"};